var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"bars",class:_vm.name})
}
var staticRenderFns = []

export { render, staticRenderFns }